import { Component, OnDestroy, OnInit } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Subscription } from 'rxjs/Subscription';
import { NLogLevel } from '../../enums/nlog-level';
import { EFMigrationsHistory } from "../../models/ef-migrations-history.model";
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { CheckingMechanismService } from "../../services/checking-mechanism.service";
import { EFMigrationsHistoryService } from "../../services/efmigrations-history.service";



@Component({
    selector: 'app-checking-mechanism',
    template: require('./checking-mechanism.component.html'),
    styles: [require('./checking-mechanism.component.css')],
    animations: [fadeInOut]
})
export class CheckingMechanismComponent implements OnInit, OnDestroy {

    public isFileUploadVisible = false;
    public uploadedFiles: any[] = [];
    serverHealthMsgs: any = [];
    options: any;
    isHealthRequestDone = false;
    showServerHealthAlert = false;
    isSuccess = true;
    lstefMigrationsHistory: EFMigrationsHistory[] = [];
    private subscribers: Subscription[] = [];
    migrationCount :number = 0;
    constructor(private checkingMechanismService: CheckingMechanismService,
        private efmigrationshistoryservice: EFMigrationsHistoryService, private alertService: AlertService) { }


    ngOnInit() {

        const efSubscriber = this.efmigrationshistoryservice.getAll().subscribe((res: EFMigrationsHistory[]) => {
            this.lstefMigrationsHistory =  res;
            this.migrationCount = res !=null ? res.length : 0 ;
        });

        this.subscribers.push(efSubscriber);
        this.checkServerHealth();

    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    checkEmail() {
        const chkmgSubscriber = this.checkingMechanismService.checkEmail().subscribe((res: boolean) => {
            if (res) {
                this.alertService.showMessage('Email', 'Email functionality is working normal', MessageSeverity.success);

            } else {

                this.alertService.showMessage('Email', 'Email functionality is not working normal', MessageSeverity.error);
            }
        });

        this.subscribers.push(chkmgSubscriber);
    }

    checkDBConnection() {
        const chkMeSubscriber = this.checkingMechanismService.checkDBConnection().subscribe((res: any) => {
          
            if (res.Success) {
                this.alertService.showMessage('Database connection', 'Database connection is working normal', MessageSeverity.success);
            } else {
                this.alertService.showMessage('Database connection', 'Database connection is not working normal', MessageSeverity.error);
            }
        });

        this.subscribers.push(chkMeSubscriber);
    }

    onUpload(event, files) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }
    }

    checkNLog(level: number) {
        const chkNgSubscriber = this.checkingMechanismService.checkNLog(level).subscribe((res: boolean) => {
            if (res) {
                this.alertService.showMessage('NLog', NLogLevel[level] + ' level logging is working normal', MessageSeverity.success);
            } else {
                this.alertService.showMessage('NLog', NLogLevel[level] + ' level logging is not working normal', MessageSeverity.error);
            }
        });

        this.subscribers.push(chkNgSubscriber);
    }

    checkServerHealth() {
        if (!this.isHealthRequestDone) {
            this.isHealthRequestDone = true;
            this.showServerHealthAlert = false;
            this.serverHealthMsgs = [];
            const chkshSubscriber = this.checkingMechanismService.checkServerHealth().subscribe((res: any) => {
                
                if (res) {
                    setTimeout(() => {
                        this.isSuccess = true;
                        this.showServerHealthAlert = true;
                        this.alertService.showMessage('Server', 'Server health is Good!', MessageSeverity.success);

                    }, 1000);
                    this.serverHealthMsgs = res;
                }
            }, err => {
                this.isSuccess = false;

                this.serverHealthMsgs = err.error;
                setTimeout(() => {
                    this.showServerHealthAlert = true;
                    this.alertService.showMessage('Server', 'Server health is not Good!', MessageSeverity.error);
                }, 1000);

            });

            this.subscribers.push(chkshSubscriber);
        }
    }


}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/checking-mechanism/checking-mechanism.component.ts